var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 84,
    viewBox: "0 0 80 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.125 20.1469L41.9375 1.9031C41.4375 1.57498 40.75 1.44373 40 1.44373C39.25 1.44373 38.5625 1.6406 38.0625 1.9031L8.0625 20.2125C7 20.8687 6.25 22.5094 6.25 23.7562V60.3094C6.25 61.0312 6.375 61.8844 6.875 62.6062L73.625 21.9187C73.25 21.1312 72.6875 20.5406 72.125 20.1469Z",
    fill: "#659AD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6875 62.5406C7 63.0656 7.4375 63.525 7.875 63.7875L38 82.0969C38.5 82.425 39.1875 82.5563 39.9375 82.5563C40.6875 82.5563 41.375 82.3594 41.875 82.0969L71.875 63.7875C72.9375 63.1313 73.6875 61.4907 73.6875 60.2438V23.6906C73.6875 23.1 73.625 22.4438 73.3125 21.8531L6.6875 62.5406Z",
    fill: "#03599C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3125 49.9406C50.6875 54.7969 45.6875 58.0781 40 58.0781C31.5625 58.0781 24.6875 50.8594 24.6875 42C24.6875 33.1406 31.5625 25.9219 40 25.9219C45.6875 25.9219 50.6875 29.2031 53.3125 34.125L61.4375 29.2031C57.1875 21.3938 49.1875 16.0781 40 16.0781C26.375 16.0781 15.3125 27.6938 15.3125 42C15.3125 56.3062 26.375 67.9219 40 67.9219C49.125 67.9219 57.125 62.6719 61.375 54.9281L53.3125 49.9406Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.e3cdf3147fbb6ed3428ccf3459c5e928.svg";
export { ForwardRef as ReactComponent };